import React from "react";
import logoFooter from "../../assets/LogoRodape.png";

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 dark:bg-black border-t border-gray-200 dark:border-gray-900 py-12 sm:py-16 px-4 sm:px-6 transition-colors duration-300">
      <div className="container mx-auto max-w-7xl">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div className="sm:col-span-2">
            <img
              src={logoFooter}
              alt="Easyfit Logo"
              className="h-7 sm:h-8 mb-4 sm:mb-6"
            />
            <p className="text-gray-600 dark:text-gray-400 max-w-md text-sm sm:text-base">
              Plataforma inteligente que conecta personal trainers e alunos
              através de tecnologia e inteligência artificial.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-gray-900 dark:text-white">Empresa</h4>
            <ul className="space-y-2 sm:space-y-3 text-gray-600 dark:text-gray-400 text-sm sm:text-base">
              <li>
                <a
                  href="/sobre"
                  className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                >
                  Sobre nós
                </a>
              </li>
              <li>
                <a
                  href="/termos-de-uso"
                  className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                >
                  Termos de Uso
                </a>
              </li>
              <li>
                <a
                  href="/politica-de-privacidade"
                  className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                >
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-gray-900 dark:text-white">Contato</h4>
            <ul className="space-y-2 sm:space-y-3 text-gray-600 dark:text-gray-400 text-sm sm:text-base">
              <li>
                <a
                  href="mailto:easyfithot@gmail.com"
                  className="hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                >
                  easyfithot@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-gray-900 pt-6 sm:pt-8">
          <p className="text-center text-gray-500 dark:text-gray-500 text-xs sm:text-sm">
            &copy; {new Date().getFullYear()} Easyfit. Todos os direitos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
